import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=42371c35&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"
import style1 from "./Coupons.vue?vue&type=style&index=1&id=42371c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42371c35",
  null
  
)

export default component.exports